import { useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import PickSection from "./components/PickSection";
import AnimeGrid from "./components/AnimeGrid";
import Collections from "./components/Collections";
import Faq from "./components/Faq";
import About from "./components/About";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  const [keyword, setKeyword] = useState("");

  return (
    <>
      <Navbar />
      <main>
        <Hero onSearch={setKeyword} />
        <PickSection />
        <AnimeGrid keyword={keyword} />
        <Collections />
        <Faq />
        <About />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}